import { SxProps, Theme } from '@mui/material';

export const DpContentCardSX = (example: boolean): SxProps<Theme> => ({
	position: example ? '' : 'fixed',
	bottom: '15px',
	right: '0px',
	zIndex: 1000,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export const DpLinkSX: SxProps<Theme> = {
	width: '53px',
	height: '57px',
	backgroundColor: '#2AB53F',
	borderTopLeftRadius: '6px',
	borderBottomLeftRadius: '6px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	cursor: 'pointer',
	boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
	position: 'relative',
	'&:hover + .tooltip': {
		display: 'block',
	},
};

export const DpImageSX: SxProps<Theme> = {
	width: '35px',
	height: '35px',
};

export const DpTooltipSX: SxProps<Theme> = {
	position: 'absolute',
	right: '70px',
	top: '50%',
	transform: 'translateY(-50%)',
	backgroundColor: 'rgba(0, 0, 0, 0.8)',
	color: '#fff',
	padding: '10px',
	bordeRadius: '6px',
	display: 'none',
	whiteSpace: 'nowrap',
	fontFamily: 'Roboto',
	'&:hover': {
		display: 'block',
	},
	'&::before': {
		content: '""',
		position: 'absolute',
		right: '-10px',
		top: '50%',
		width: 0,
		height: 0,
		borderLeft: '10px solid rgba(0, 0, 0, 0.8)',
		borderTop: '10px solid transparent',
		borderBottom: '10px solid transparent',
		transform: 'translateY(-50%)',
	},
};
